import { render } from "./IconHealthcare.vue?vue&type=template&id=20246833"
import script from "./IconHealthcare.vue?vue&type=script&lang=js"
export * from "./IconHealthcare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__